import { FC, useEffect, useState } from "react";
import { Option } from "../../components/options/types";
import { FINANCE_ROUTES_OPTIONS } from "./data";
import Options from "../../components/options";
import { Outlet, useNavigate } from "react-router";

const Finance: FC = () => {
  const navigate = useNavigate();
  const [selectedOption, setSelectedOption] = useState<Option<string>>(
    FINANCE_ROUTES_OPTIONS.filter(
      (r) => r.value === window.location.pathname
    )[0]!
  );

  useEffect(() => {
    if (!selectedOption) {
      setSelectedOption(FINANCE_ROUTES_OPTIONS[0]);
      return;
    }

    navigate(selectedOption.value);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedOption]);

  return (
    <div style={{ margin: "1rem 0" }}>
      <Options
        options={FINANCE_ROUTES_OPTIONS}
        selectedOption={selectedOption}
        setSelectedOption={setSelectedOption}
        itemStyle={{ padding: "0 20px" }}
      />
      <Outlet />
    </div>
  );
};

export default Finance;
